import { X } from "lucide-react";
import type { ProductInfoCreative } from "@/feature/ads/mock/productsInfoCreative.mock";

interface AdStudioHeaderProps {
  product: ProductInfoCreative;
  onClose: () => void;
}

export function AdStudioHeader({ product, onClose }: AdStudioHeaderProps) {
  return (
    <div className="flex items-start justify-between px-8 py-6 border-b border-gray-100">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0 overflow-hidden">
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Ad Studio</h2>
          <p className="mt-1 text-sm text-gray-500">{product.name}</p>
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
        aria-label="Cerrar"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}

